import { Injectable } from "@angular/core";

@Injectable()
export class RotateImageService {

	/**
	 * event to convert image url into base64 string
	 * @param imageUrl
	 */
	async getBase64ImageFromUrl(imageUrl): Promise<any> {
		const res = await fetch(imageUrl);
		const blob = await res.blob();

		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.addEventListener("load", function () {
				resolve(reader.result);
			}, false);

			reader.onerror = (error) => {
				return reject(error);
			};
			reader.readAsDataURL(blob);
		})
	}
}

